import { bl_inv_stock_replenishment_run_hdr_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_run_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class StockReplenishmentRunHdrModel extends BaseContainerModel {
  bl_inv_stock_replenishment_run_hdr: bl_inv_stock_replenishment_run_hdr_RowClass = new bl_inv_stock_replenishment_run_hdr_RowClass();
}
